import { useAuth } from "@/context/AuthContext";
import { fmtCup, fmtUsdt, STATUS_COLOR, STATUS_ES } from "@/lib/api";

export function Price({ usdt, size = "md", className = "", testId }) {
  const { settings } = useAuth();
  const big = size === "lg";
  return (
    <div className={`flex flex-col ${className}`} data-testid={testId}>
      <span className={`font-mono font-semibold text-cyan-300 ${big ? "text-2xl" : "text-base"}`}>{fmtUsdt(usdt)} USDT</span>
      <span className={`font-mono text-emerald-400 ${big ? "text-sm" : "text-xs"}`}>≈ {fmtCup(usdt * settings.cup_rate)} CUP</span>
    </div>
  );
}

export function StatusBadge({ status, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_COLOR[status] || "bg-slate-500/20 text-slate-300"}`}>
      {STATUS_ES[status] || status}
    </span>
  );
}

const STEPS = ["pending", "accepted", "assigned", "in_transit", "completed"];
export function OrderTimeline({ status }) {
  const idx = status === "cancelled" || status === "disputed" ? -1 : STEPS.indexOf(status);
  return (
    <div className="flex items-center gap-1 w-full" data-testid="order-timeline">
      {STEPS.map((s, i) => (
        <div key={s} className="flex-1 flex flex-col items-center gap-1">
          <div className={`h-2 w-full rounded-full ${i <= idx ? "bg-gradient-to-r from-cyan-400 to-emerald-400" : "bg-secondary"}`} />
          <span className={`text-[10px] sm:text-xs text-center leading-tight ${i <= idx ? "text-foreground" : "text-muted-foreground"}`}>{STATUS_ES[s]}</span>
        </div>
      ))}
    </div>
  );
}

export function Empty({ text }) {
  return <div className="neon-card p-8 text-center text-muted-foreground" data-testid="empty-state">{text}</div>;
}

export function Section({ title, subtitle, action, children }) {
  return (
    <section className="fade-up">
      <div className="flex items-end justify-between gap-3 mb-4">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h2>
          {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
